import * as Yup from 'yup'

export const NEW_MESSAGE_SCHEMA = Yup.object().shape({
  message: Yup.string().required('Please enter message.').min(1, 'Please enter valid message'),
  attachments: Yup.array(),
})
